<script>
import CountDown from '../router/views/welly/popup/countDown.vue'

export default {
    components: { CountDown },
    props: {
        order: {
            type: Object,
        },
        column: {
            type: String
        }

    },
    data() {
        return {
            glutenFree: false,
            vegan: false,
            vegetarian: false,
            keto: false,
            note: false,
            observations: false,
        };
    },


    mounted() {
        this.getTypes()
    },
    watch: {
        order: function() {
            this.getTypes()
        }
    },
    methods: {
        getTypes() {
            const dishes = this.order.dishes
            for (const dish of dishes) {
                const type = dish.type
                if (type.indexOf('Gluten free') != -1) this.glutenFree = true
                if (type.indexOf('Vegan') != -1) this.vegan = true
                if (type.indexOf('Vegetarian') != -1) this.vegetarian = true
                if (type.indexOf('Healthy') != -1) this.keto = true
                const observation = dish.observations
                if (observation != "" && observation != null) this.observations = true
            }
        },
    }
}
</script>

<template>
    <div class="card-welly">
        <div class="new-order-message" v-show="order?.isNew && column=='new'">
            ¡Nuevo!
        </div>
        <div class="row">
            <div class="col-md-11 container-welly" :class="order?.isNew && column=='new' ? 'new-order' : ''">
                <div class="container-welly-info">
                    <div style="width: 100%">
                        <h5 class="pedido-welly-text">Pedido <b>#{{ order?.code }}</b></h5>
                        <div class="row item-request" v-for="(dish, index) in order?.dishes" :key="index">
                            <div class="cant-green-pedido-welly">
                                X {{ dish?.quantity }}
                            </div>
                            <div style="width: fit-content">
                                {{ dish?.name }}
                            </div>
                        </div>
                    </div>
                    <div class="card-remaining-spacer">
                        <div v-if="column=='preparing'" class="card-remaining">
                            <p>Restantes</p>
                            <CountDown :resize="true" :time="order?.prepTime" :createdTime="order?.status?.createdAt"/>
                        </div>
                    </div>
                </div>
                <div class="row ver-detalle-welly">
                    <p @click="$emit('view-detail')" style="cursor:pointer;">Ver detalle</p>
                </div>
            </div>
            <div class="extra-info-order-cont">
                <div class="extra-info-order special-order" v-show="observations">
                    <p>Pedido especial.</p>
                </div>

                <div class="extra-info-order confirmedRider" v-show="order.rider">
                    <p>Repartidor confirmado.</p>
                </div>
            </div>

            <div class="col-md-1 options-right">
                <div class="option-welly-no-gluten" v-show="glutenFree">
                    <img src="@/assets/images/special/glutenfree-white.svg" height="15" />
                </div>
                <div class="option-welly-no-milk" v-show="vegan">
                    <img src="@/assets/images/special/vegan-icon2.svg" height="13" />
                </div>
                <div class="option-welly-no-hoja" v-show="vegetarian">
                    <img src="@/assets/images/special/veggie-icon2.svg" height="15" />
                </div>
                <div class="option-welly-no-healthy" v-show="keto">
                    <img src="@/assets/images/special/keto-icon2.svg" height="15" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/components/order-card';
</style>
